<template>
  <div class="discussion-card-section">
    <div class="avatar avatar_sm_md brand_inverse_light_bg">
      <img v-lazy="localImg('avatar12.png')" alt="" class="avatar-img" />
    </div>

    <div class="participant-info">
      <div class="full-name font-weight-bold color_text">Henry Okafor</div>
      <div class="class-code color_grey_dark text-uppercase">kku/2020/5391</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DiscussionCard",
};
</script>

<style lang="scss" scoped>
.discussion-card-section {
  padding: 8px 5px;
  @include flex_row_start_nowrap;
  .avatar {
    border: 1px solid $brand-inverse;
    margin-right: 15px;
  }

  .participant-info {
    .full-name {
      font-size: 14px;
      line-height: 19px;
      margin-bottom: 2px;
    }

    .class-code {
      font-size: 12px;
      line-height: 16px;
    }
  }
}
</style>